import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { ApiUrlProvider } from './api-url.provider';
import { Resource } from '../shared/models/resource';
import { IProjectColumn } from '../shared/models/project-column';

@Injectable({
  providedIn: 'root'
})
export class ProjectColumnService {
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<IProjectColumn[]>>{
    return this.http.get<IApiResult<IProjectColumn[]>>(`${this.apiUrlProvider.url}/ProjectColumn`);
  }

  update(entity: Resource): Observable<IApiResult<IProjectColumn>>{
    return this.http.post<IApiResult<IProjectColumn>>(`${this.apiUrlProvider.url}/ProjectColumn/${entity.id}`, entity);
  }
}
